import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function RegulaminPlatnosci() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="payment-terms-page">
      <div className="bg-slate-900 py-8">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/">
            <Button variant="ghost" className="text-slate-400 hover:text-white mb-4">
              <ArrowLeft className="w-4 h-4 mr-2" />Strona główna
            </Button>
          </Link>
          <h1 className="font-heading font-bold text-2xl text-white">Regulamin usług płatnych i subskrypcji</h1>
          <p className="text-slate-400 mt-1">Serwis „Giełda Budowlana"</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-6 sm:p-10 space-y-8 text-slate-700 leading-relaxed">

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§1. Informacje ogólne</h2>
            <p>Niniejszy Regulamin określa zasady korzystania z usług płatnych dostępnych w serwisie internetowym „Giełda Budowlana" (dalej: „Serwis").</p>
            <p className="mt-2">Regulamin stanowi uzupełnienie Regulaminu Serwisu i ma zastosowanie wyłącznie do usług odpłatnych.</p>
            <p className="mt-2">Usługodawcą jest:</p>
            <p className="mt-1"><strong>Piotr Kowalczyk P&P Profinish</strong>, prowadzący działalność gospodarczą</p>
            <ul className="list-none mt-1 space-y-0.5 text-sm text-slate-600">
              <li>adres: ul. Banderii 4/276, 01-164 Warszawa</li>
              <li>NIP: 7962883242, REGON: 527450940</li>
              <li>e-mail: p.p.profinish@gmail.com</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§2. Rodzaje usług płatnych</h2>
            <p>W Serwisie dostępne są następujące usługi płatne:</p>
            <div className="mt-3 p-4 bg-slate-50 rounded-lg">
              <h3 className="font-bold text-slate-900">a) Subskrypcja konta firmowego</h3>
              <p className="mt-1">Umożliwiająca w szczególności:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
                <li>wysyłanie wiadomości i zapytań do ogłoszeń,</li>
                <li>korzystanie z interaktywnego czatu z zapisem historii rozmów,</li>
                <li>dostęp do numerów telefonów zamieszczonych w ogłoszeniach,</li>
                <li>pełne korzystanie z funkcjonalności konta firmowego.</li>
              </ul>
            </div>
            <div className="mt-3 p-4 bg-slate-50 rounded-lg">
              <h3 className="font-bold text-slate-900">b) Promowanie konta firmowego</h3>
              <p className="mt-1">Polegające na:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1 text-sm">
                <li>wyróżnieniu profilu firmy w Serwisie,</li>
                <li>prezentacji firmy na stronie głównej jako firmy polecanej,</li>
                <li>proponowaniu profilu firmy użytkownikom podczas dodawania ogłoszeń, na podstawie przypisanych kategorii.</li>
              </ul>
              <p className="mt-2 text-sm">Promowanie konta firmowego jest usługą dodatkową i obowiązuje przez okres <strong>7 dni</strong>.</p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§3. Subskrypcja</h2>
            <p>Subskrypcja dostępna jest w następujących wariantach czasowych:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>30 dni</li>
              <li>60 dni</li>
              <li>90 dni</li>
              <li>365 dni</li>
            </ul>
            <p className="mt-2">Subskrypcja odnawia się automatycznie po upływie wybranego okresu, na kolejny taki sam okres.</p>
            <p className="mt-1">Użytkownik może w każdej chwili anulować subskrypcję z poziomu swojego konta.</p>
            <p className="mt-1">Anulowanie subskrypcji skutkuje brakiem jej odnowienia po zakończeniu aktualnego okresu rozliczeniowego.</p>
            <p className="mt-1">Serwis nie oferuje okresu próbnego.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§4. Płatności</h2>
            <p>Płatności za usługi realizowane są w formie elektronicznej.</p>
            <p className="mt-1">Operatorem płatności jest zewnętrzny dostawca (np. Stripe).</p>
            <p className="mt-2">Dostępne metody płatności mogą obejmować m.in.:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>karty płatnicze,</li>
              <li>BLIK,</li>
              <li>Przelewy24.</li>
            </ul>
            <p className="mt-2">Ceny usług podawane są w Serwisie w sposób jednoznaczny i zawierają wszystkie obowiązkowe opłaty.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§5. Rozpoczęcie świadczenia usługi</h2>
            <p>Usługa płatna zostaje aktywowana niezwłocznie po zaksięgowaniu płatności.</p>
            <p className="mt-1">Z chwilą aktywacji usługi użytkownik wyraża zgodę na rozpoczęcie świadczenia usługi cyfrowej przed upływem terminu do odstąpienia od umowy.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§6. Brak prawa do odstąpienia od umowy</h2>
            <p>Zgodnie z obowiązującymi przepisami, użytkownik traci prawo do odstąpienia od umowy w przypadku:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>rozpoczęcia świadczenia usługi cyfrowej za wyraźną zgodą użytkownika,</li>
              <li>po poinformowaniu go o utracie prawa do odstąpienia.</li>
            </ul>
            <p className="mt-2">Informacja ta jest przekazywana użytkownikowi przed dokonaniem płatności.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§7. Odpowiedzialność</h2>
            <p>Usługodawca nie gwarantuje, że korzystanie z usług płatnych doprowadzi do nawiązania współpracy, pozyskania zleceń lub zawarcia umów pomiędzy użytkownikami.</p>
            <p className="mt-1">Usługodawca nie ponosi odpowiedzialności za treści publikowane przez użytkowników ani za rezultaty ich współpracy.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§8. Reklamacje dotyczące usług płatnych</h2>
            <p>Reklamacje dotyczące usług płatnych można składać drogą e-mailową na adres: <a href="mailto:p.p.profinish@gmail.com" className="text-orange-600 hover:underline">p.p.profinish@gmail.com</a>.</p>
            <p className="mt-1">Reklamacje rozpatrywane są w terminie do 14 dni od dnia ich otrzymania.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§9. Zmiany regulaminu</h2>
            <p>Usługodawca zastrzega sobie prawo do zmiany niniejszego Regulaminu.</p>
            <p className="mt-1">Zmiany wchodzą w życie w terminie wskazanym przez Usługodawcę.</p>
            <p className="mt-1">Zmiany nie wpływają na już opłacone okresy subskrypcji.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900 mb-3">§10. Postanowienia końcowe</h2>
            <p>W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy prawa polskiego.</p>
            <p className="mt-1">Regulamin obowiązuje od dnia publikacji w Serwisie.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
